// Hook (use-require-auth.js)
import { useEffect } from "react";
import env from "utils/env";
import { getNextOnboardingAthenaPath } from "utils/get-next-onboarding-athena-path";
import { useAuth } from "./use-auth";
import useRouter from "./use-router";

const useRequireAthenaAuth = () => {
  const auth = useAuth();
  const { push, location } = useRouter();
  useEffect(() => {
    const nextPath = getNextOnboardingAthenaPath(location.pathname, auth.user);
    if (env("NODE_ENV") === "development") {
      // eslint-disable-next-line no-console
      console.log(`redirect to ${nextPath}`, {
        path: location.pathname,
        user: auth.user,
      });
    }
    if (nextPath) {
      push(nextPath);
    }
  }, [auth.user, location.pathname, push]);

  return { ...auth };
};
export default useRequireAthenaAuth;
